import React, { Component, PropTypes } from 'react';
import { FormattedNumber } from 'react-intl';
import Loader from 'components/Material/Loader';
import { StoreOverviewActions } from 'actions';
import DiscountField from 'components/DiscountField';
import Css from 'Css';
const { Units, Colors } = Css;

const css = oxygenCss({
  root: {
    backgroundColor: Colors.material.coursio[500].hex
  },
  item: {
    padding: `0 ${4 * Units.base}px ${4 * Units.base}px ${4 * Units.base}px`,
    '@phone': {
      padding: Units.base
    }
  },
  header: {
    fontSize: 24,
    lineHeight: '36px',
    margin: 0,
    padding: 0
  },
  title: {
    fontSize: 16,
    lineHeight: '28px',
    margin: 0
  },
  price: {
    padding: `${Units.base / 2}px ${Units.base * 4}px`,
    border: 'solid 1px #EEEEEE',
    fontSize: 18,
    lineHeight: '30px',
    backgroundColor: '#FFFFFF',
    color: '#333333',
    display: 'inline-block',
    letterSpacing: '2px',
    marginTop: Units.base * 2
  },
  discountFieldContainer: {
    padding: Units.base
  }
});

class ItemDetails extends Component {
  static propTypes = {
    name: PropTypes.string,
    currency: PropTypes.string,
    slug: PropTypes.string,
    price: PropTypes.object,
    store: PropTypes.string,
    activeDiscountCount: PropTypes.number,
    type: PropTypes.number,
    id: PropTypes.number
  };

  static contextTypes = {
    muiTheme: PropTypes.object,
    getIntlMessage: PropTypes.func
  };

  refresh = () => {
    const { type, slug } = this.props;
    StoreOverviewActions.findBySlug(type, slug);
  };

  render() {
    const { name, currency, price, activeDiscountCount } = this.props;
    const { getIntlMessage } = this.context;
    const hasDiscount =
      true || !!(activeDiscountCount && activeDiscountCount > 0);
    if (!name) {
      return <Loader />;
    }
    return (
      <div className={css.root}>
        <div className={css.item}>
          <h2 className={css.title}>{getIntlMessage('store.joinCourse')}</h2>
          <h1 className={css.header}>{name}</h1>
          <div className={css.price}>
            <FormattedNumber
              style="currency"
              currency={currency}
              value={Math.round(price.discounted)}
            />
          </div>
        </div>
        {hasDiscount && (
          <div className={css.discountFieldContainer}>
            <DiscountField fullWidth onChange={this.refresh} />
          </div>
        )}
      </div>
    );
  }
}

export default ItemDetails;



// WEBPACK FOOTER //
// ./src/js/components/Store/ItemDetails.js